// extracted by mini-css-extract-plugin
export var concept = "style-module--concept--uJLvZ";
export var contents = "style-module--contents--JjHmi";
export var heading = "style-module--heading--xQduP";
export var headings = "style-module--headings--9ooYk";
export var image = "style-module--image--zOBBv";
export var text = "style-module--text--WIuNJ";
export var title = "style-module--title--PnKpe";